(function () {
  class ScrollbarToggle {
    constructor(selector, delay = 600) {
      this.container = document.querySelector(selector);
      this.delay = delay;
      this.timeout = null;

      if (this.container) {
        this.init();
      }
    }

    init() {
      this.container.addEventListener('scroll', this.onScroll.bind(this));
    }

    onScroll() {
      this.container.classList.add('show-scrollbar');
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.container.classList.remove('show-scrollbar');
      }, this.delay);
    }
  }

  // Initialize on DOM ready
  document.addEventListener('DOMContentLoaded', function () {
    new ScrollbarToggle('.header__mobile__nav__scroller');
  });
})();